import {EventStoredObject} from "../../../@types/response";
import {useContext} from "react";
import {ModalsContext} from "../modals/ModalsContext";
import {MODALS_TYPES} from "../../../constants/ModalsConstants";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

export default function Odds({
                                 backOdd,
                                 alert,
                                 event,
                             }: { backOdd: number, alert: any, event: EventStoredObject }) {

    const {setOpenedModalsCallback, setModalsDataCallback} = useContext(ModalsContext);

    return (
            <div className='flex justify-between'>
                <div
                        data-value={backOdd.toFixed(2)}
                        className={`p-1 rounded-md mx-1 text-center cursor-pointer w-full`}
                        onClick={() => {
                            if (!event) return
                            setModalsDataCallback(MODALS_TYPES.BOOK_PLAYER_MODAL, {
                                event: event,
                                alert: alert,
                                odd: backOdd
                            });
                            setOpenedModalsCallback(MODALS_TYPES.BOOK_PLAYER_MODAL, true);
                        }}
                >
                    <div
                    >
                        {backOdd.toFixed(2)}
                        <div className='absolute -right-2 top-0 cursor-pointer  text-red-500 btn-remove'>
                            <FontAwesomeIcon
                                    icon={faTimes}
                            />
                        </div>
                    </div>
                </div>
            </div>
    )
}
